
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

@Component({})
export default class ProductTypeField extends Vue {
  @Prop()
  placeholder?: string;

  @Prop()
  value?: any;

  @Prop()
  multiple?: boolean;

  @Prop()
  filterable?: boolean;

  @Prop()
  allowCreate?: boolean;

  @Prop()
  readonly?: boolean;

  @Prop()
  disabled?: boolean;

  val: any = '';

  options = [
    {
      value: 0,
      label: '单店核销',
    },
    {
      value: 1,
      label: '多店核销',
    },
  ];

  @Watch('value')
  watchValue() {
    if (this.value !== null && this.value !== undefined && this.value !== '') {
      this.val = this.value;
    } else {
      this.val = '';
    }
  }

  handleChange(val: string) {
    this.val = val;
    this.$emit('input', val);
  }

  mounted() {
    this.watchValue();
  }
}
